import K from "utilities/constants";
import { formatDisplayTime, toShortUSFormat } from "utilities/dateUtility";
import { UsersIcon } from "features/dashboard/components/icons/UsersIcon";
import { PhoneIcon } from "features/dashboard/components/icons/PhoneIcon";
import { CalendarIcon } from "features/dashboard/components/icons/CalendarIcon";
import { FileCheckIcon } from "features/dashboard/components/icons/FileCheckIcon";

const getDueDate = (dateField, value, daysAgo) => {
  const fieldToDisplay = K.Candidate.DateFields[dateField];
  if (!fieldToDisplay) return null;

  const showsPlaceholder = daysAgo !== undefined;
  if (!value && !showsPlaceholder) return null;

  const formattedValue = value ? toShortUSFormat(value) : K.NullPlaceholder;
  const agoSuffix = showsPlaceholder && value ? ` (${daysAgo} days ago)` : "";

  return `${fieldToDisplay.label}: ${formattedValue}${agoSuffix}`;
};

export const TASK_GROUPS = [
  {
    key: "prospects",
    testId: "prospects",
    label: "Prospects (30+ Days)",
    icon: <UsersIcon style={{ color: "var(--gray-200)" }} />,
    getStatus: ({ subStatus }) => subStatus.name,
    getDueDate: ({ due: { date, daysAgo } }) =>
      `Last Contact: ${toShortUSFormat(date)} (${daysAgo} days ago)`,
    showDueDateForToday: true,
    getDescription: () =>
      "Candidates in Prospect status (Sourced, First Contacted, Second Contacted, or Third Contacted) with no contact for 30 or more days.",
  },
  {
    key: "phoneScreensFollowUp",
    testId: "phone-screens-follow-up",
    label: "Phone Screens Follow-up (4+ Days)",
    icon: <PhoneIcon style={{ color: "var(--orange-300)" }} />,
    getStatus: ({ otherStatus }) => otherStatus.name,
    getDueDate: ({ due: { date, daysAgo } }) =>
      `Last Contact: ${toShortUSFormat(date)} (${daysAgo} days ago)`,
    showDueDateForToday: true,
    getDescription: () =>
      "Candidates in S2 Interview status with Contacted sub-status who haven't been followed up within 4 days of the last contact.",
  },
  {
    key: "phoneScreensScheduled",
    testId: "phone-screens-scheduled",
    label: "Phone Screens Scheduled",
    icon: <PhoneIcon style={{ color: "var(--orange-300)" }} />,
    getStatus: ({ subStatus }) => subStatus.name,
    getDueDate: ({ due: { date, dateField } }) => getDueDate(dateField, date),
    getDescription: (dueLabel) =>
      `Candidates in S2 Interview status with Scheduled sub-status where the S2 Interview Scheduled Date is ${dueLabel}.`,
  },
  {
    key: "scheduledInterviews",
    testId: "scheduled-interviews",
    label: "Scheduled Interviews",
    icon: <CalendarIcon style={{ color: "var(--purple-100)" }} />,
    getStatus: ({ subStatus }) => subStatus.name,
    getDueDate: ({ due: { date, dateField } }) => getDueDate(dateField, date),
    getDueTime: ({ due: { time } }) =>
      `Interview Time: ${formatDisplayTime(time)}`,
    getDescription: (dueLabel) =>
      `Candidates in Client Interview status (Awaiting Feedback, Second Interview, or Third Interview sub-status) where the First, Second, or Third Interview Date is ${dueLabel}.`,
  },
  {
    key: "offersToStart",
    testId: "offers-to-start",
    label: "Offers to Start",
    icon: <FileCheckIcon style={{ color: "var(--green-100)" }} />,
    getStatus: ({ subStatus }) => subStatus.name,
    getDueDate: ({ due: { date, dateField, daysAgo } }) =>
      getDueDate(dateField, date, daysAgo),
    showDueDateForToday: true,
    getDescription: (dueLabel) =>
      `Candidates in Offer status with Accepted sub-status where the Pending Start Date is ${dueLabel}.`,
  },
];
